// ボスの致命 (主人公が崩れた時の決め技) の傷 (2026-10-10 既定にした・DEV ?finisherDmg=0|off|60|40|35|25 で替えて比べられる)。
//
// 既定 = 共有の致命 (PLAYER_DAMAGE.finisher = 60) の傷を、「その難易度の主人公の最大体力の 4 割」にする。
//   ユーザー 10-10 (検収パック D-1 のメモ):「ボスの致命は食らったらの残り体力次第で即死級でいい。でも、体幹を崩してしまった時の救済と言うか
//   逆転の手段として弾けるようにした。だからプレイヤーの体力の６割くらいの火力があって良い」→ 6 割で入れた。
//   ユーザー 10-18 (答えるページ「言葉と騎士の致命」③): 騎士・花嫁・介錯とも「全部4割」へ下げる。
//   最大体力は難易度を通した後の実効値 (difficulty.ts playerMaxHp = 千秋楽 100 / 初演 200) なので、
//   千秋楽 = 40・初演 = 80。致命は初演でも圧縮しない (difficulty.ts playerIncomingDamage の約束のまま)。
//
// 背景 = C:\dev\LUNAIRE-notes\assets\2026-10-09-night-review\analysis\senshuraku-stuck-points.md の1番:
//   騎士・花嫁・介錯の致命は共有の 60。千秋楽は体力 100 なので、崩れた時点で 6 割を持っていかれる。
//   10-10 の答えは「下げない (6 割のまま)」、10-18 に 4 割へ。戴冠獣は 07-05 に 60→25 へ下げて「これでOK」(docs/ledger/bosses.md)。
//
// 効かせ方:
//   - ボスの致命 (bossFinisher) の傷が 共有の 60 の時だけ替える。専用の値を持つ戴冠獣 (25)・覚醒王 (32) は触らない。
//   - playerLethal (即死) は致命ではないので触らない。他の技の傷・体幹の傷・致命の演出の長さ (溜め・当たり・戻り・止め) も変えない。
//   - DEV の ?finisherDmg=: 0 / off / 60 = 前の決め方 (共有の 60 のまま・初演も 60) / 40 / 35 / 25 = その値で固定 / ほか・指定なし = 既定 (最大体力の 4 割)。
//     配布版は URL を読まない (game.ts の DEV の箱の中でだけ setFinisherDamage を呼ぶ)。
import { PLAYER_DAMAGE } from './balance'

/** 既定の傷 = 主人公の実効の最大体力に掛ける割合。 */
export const FINISHER_HP_RATIO = 0.4

/** 40 / 35 / 25 = その値で固定 / 'old' = 共有の 60 のまま / null = 既定 (最大体力の 4 割)。 */
export type FinisherDamageOverride = 40 | 35 | 25 | 'old' | null

let override: FinisherDamageOverride = null

/** URL の値から切り替える。'40' / '35' / '25' = 固定・'0' / 'off' / '60' = 旧・それ以外 (知らない値・指定なし) = 既定。 */
export function setFinisherDamage(value: string | null | undefined): FinisherDamageOverride {
  override = value === '40' ? 40 : value === '35' ? 35 : value === '25' ? 25
    : value === '0' || value === 'off' || value === '60' ? 'old' : null
  return override
}
export function finisherDamageSetting(): FinisherDamageOverride { return override }

/**
 * ボスの致命 1 発の傷。base = その技の damage・maxHp = 主人公の実効の最大体力 (difficulty.ts playerMaxHp)。
 * 共有の 60 だけを替える (専用の値を持つ技はそのまま)。
 */
export function finisherDamageFor(base: number, maxHp: number): number {
  if (base !== PLAYER_DAMAGE.finisher || override === 'old') return base
  return override ?? Math.round(maxHp * FINISHER_HP_RATIO)
}
